'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _upload_sign = require('../actions/upload_sign');

var INITIAL_STATE = {
    isFetching: false,
    error: null
};

var uploadSignReducer = function uploadSignReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _upload_sign.FETCH_UPLOADSIGN_REQUEST:
            return _extends({}, state, {
                isFetching: true,
                error: null
            });
        case _upload_sign.FETCH_UPLOADSIGN_SUCCESS:
            var accessid = action.accessid,
                policy = action.policy,
                signature = action.signature,
                dir = action.dir,
                host = action.host,
                callback = action.callback;

            return _extends({}, state, {
                accessid: accessid, policy: policy, signature: signature, dir: dir, host: host, callback: callback,
                isFetching: false,
                lastUpdated: action.receivedAt,
                error: null
            });
        case _upload_sign.FETCH_UPLOADSIGN_FAILURE:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

exports.default = uploadSignReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/upload_sign.js
// module id = 903
// module chunks = 0